/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { SECTION } from 'feature/feature-helpers';
import { TopicListFeature } from 'open-modules/cbcrc/feature/admin/topic-list';
import { VideoVotingListFeature } from 'open-modules/zdf/feature/admin/video-voting-list';
import { t } from 'util/stdtypes';

import { AdminModLinkFeature, DeveloperToolsFeature, EditorialDashFeature, NewModLinkFeature, SettingsFeature } from './admin-mod-link';
import { AdminUsersFeature } from './admin-users';
import { AdminUsersImportFeature } from './admin-users-import';
import { EmailPreviewFeature } from './email-preview';
import { PuppetSupportFeature } from './puppet-test-support';
import { QuestionListFeature } from './question-list';

export const adminFeatures: FeatureGroup[] = [
    SECTION(t('Admin Modules'), [
        AdminUsersFeature,
        QuestionListFeature,
        TopicListFeature,
        VideoVotingListFeature,
        EmailPreviewFeature,
        AdminUsersImportFeature,
    ]),
    SECTION(t('Quick links'), [AdminModLinkFeature, NewModLinkFeature, EditorialDashFeature, SettingsFeature, DeveloperToolsFeature]),
    SECTION(t('Screens'), [PuppetSupportFeature]),
];

export const adminDefaultConfig = {
    admin_link_mod: true,
    admin_new_link_mod: true,
    editorialtopic: true,
    puppettest: true,
    videovotinglist: true,
    adminusers: true,
    questionlist: true,
    topiclist: true,
    emailpreview: true,
    adminusersimport: true,
    admin_editorial_dash: true,
    admin_settings: true,
    admin_developer_tools: true,
};
